import './App.css';
import { BrowserRouter,Routes, Route } from "react-router-dom";
import Home from './page/home';
import Login from './page/login';
// 导入模型缓存管理器以启动预缓存
import './utils/modelCache';

const App=()=> {
  return (
    <BrowserRouter basename="/">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/home" element={<Home />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

const NotFound = () => {
  return <div>页面没找到</div>
}
export default App;
